var l = /* @__PURE__ */ ((r) => (r.VERTICAL = "vertical", r.SPLIT = "split", r.HORIZONTAL = "horizontal", r))(l || {});
export {
  l as O
};
